import React from 'react';
import { Field } from 'formik';
import {
	StyledSelect,
	StyledFieldWrapper,
	StyledLabel,
	StyledErrorMessage
} from '../../base/forms/formik';

const SelectFormField = ({
	field = {},
	options = {}
}) => {
	return (
		<StyledFieldWrapper key={field.id}>
			<StyledLabel
				active
				htmlFor={field.fieldName}>
				{field.labelName}
			</StyledLabel>
			<Field
				name={field.fieldName}>
				{(fieldProps) => {
					const { ...props } = fieldProps.field;
					return (
						<StyledSelect
							readOnly={field.readOnly}
							active
							{...props}>
							<option key="default" value="" disabled>Veldu póstnúmer</option>
							{
								options && Object.keys(options).map((key, index) => (
									<option key={index} value={key}>{options[key]}</option>
								))
							}
						</StyledSelect>
					);
				}}
			</Field>
			<StyledErrorMessage name={field.fieldName} component="div" />
		</StyledFieldWrapper>
	);
};

export default SelectFormField;
